import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { CreateCashReconciliationButtonProps } from "models/propTypes/cashReconciliationPropTypes";
//#endregion
//#region components
import { StyledButton } from "components/common";
import { useCreateCashReconciliationDialog } from "components/cashReconciliation";
import { useCreateRevenueReport } from "components/revenueReporting";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const CreateCashReconciliationButton: React.FC<CreateCashReconciliationButtonProps> = (props) => {
  const { reloadList } = props;

  const createCashReconciliationsDialog = useCreateCashReconciliationDialog(reloadList);
  const onCreateRevenueReport = useCreateRevenueReport(createCashReconciliationsDialog, reloadList);

  return (
    <StyledButton size="sm" onClick={onCreateRevenueReport}>
      {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.CashReconciliation.CreateCashReconciliation)}
    </StyledButton>
  );
};

export default CreateCashReconciliationButton;
